import { Header } from "@tanstack/react-table";
import { Property } from "../../../rest/responses/Property";
import { useDataTableContext } from "../../../contexts/DataTableContext";

import "./ColumnResizeHandle.scss";

interface ColumnResizeHandleProps {
	header: Header<Property, unknown>;
}

export default function ColumnResizeHandle({ header }: ColumnResizeHandleProps) {
	const { table } = useDataTableContext()!;
	const columnResizeMode = table.options.columnResizeMode;

	return (
		<div
			{...{
				onDoubleClick: () => header.column.resetSize(),
				onMouseDown: header.getResizeHandler(),
				onTouchStart: header.getResizeHandler(),
				className: `resizer ${table.options.columnResizeDirection} ${
					header.column.getIsResizing() ? "isResizing" : ""
				}`,
				style: {
					transform:
						columnResizeMode === "onEnd" && header.column.getIsResizing()
							? `translateX(${
									(table.options.columnResizeDirection === "rtl" ? -1 : 1) *
									(table.getState().columnSizingInfo.deltaOffset ?? 0)
								}px)`
							: "",
				},
			}}
		/>
	);
}
